import { graphql, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';
import React from 'react';
import './main.scss';
import homeContent from '@data/home-content.yml';
import generalInfo from '@data/general-info.yml';
import { GeneralInfo, HomeContent } from '@models/home';

const Main = function Main() {
  const { heroText, gamesSectionText } = homeContent as HomeContent;
  const { socialLinks } = generalInfo as GeneralInfo;

  const images = useStaticQuery(graphql`
    query {
      logoImage: file(relativePath: { eq: "logo.png" }) {
        childImageSharp {
          fluid(maxHeight: 600, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      gamesImage: file(relativePath: { eq: "game-icons.png" }) {
        childImageSharp {
          fluid(maxHeight: 600, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      arrow: file(relativePath: { eq: "header-background-arrow.png" }) {
        childImageSharp {
          fixed(width: 1600, quality: 100) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `);

  return (
    <section className="position-relative" id="HOME">
      <div className="d-flex overflow-hidden justify-content-center col-12 row mx-0">
        <div className="main-wrapper mt-5 m-auto justify-content-center col-8 col-sm-8 col-md-6 col-lg-5">
          <Img fluid={images.logoImage.childImageSharp.fluid} alt="Logo" />
          <div className="main-text">
            <p className="text-justify">{heroText}</p>
          </div>
          <div className="header-social-icons">
            {socialLinks.map(s => (
              <a href={s.link} target="_blank">
                <i className={s.icon} />
              </a>
            ))}
          </div>
          <Img className="mt-4" fluid={images.gamesImage.childImageSharp.fluid} alt="Logo" />
          <h1 className="games-text">{gamesSectionText}</h1>
        </div>
      </div>
      <div className="arrow">
        <Img fixed={images.arrow.childImageSharp.fixed} alt="arrow" />
      </div>
    </section>
  );
};

export default Main;
